module.exports = __webpack_public_path__ + "img/Silueta-Cavidad.283b73da.png";